var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.18,
    viewBox: "0 0 14 10.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f6f6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,4C3.634,4,1.562,7.74,1.06,8.808a.66.66,0,0,0,0,.563C1.562,10.439,3.634,14.18,8,14.18c4.348,0,6.422-3.714,6.933-4.8a.686.686,0,0,0,0-.587C14.419,7.714,12.346,4,8,4ZM8,5.909A3.181,3.181,0,1,1,4.816,9.09,3.182,3.182,0,0,1,8,5.909ZM8,7.181A1.909,1.909,0,1,0,9.907,9.09,1.909,1.909,0,0,0,8,7.181Z",
    transform: "translate(-0.997 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7ecd9f9e3b0a5587c748c039f96dcdd9.svg";
export { ForwardRef as ReactComponent };